module.exports = __webpack_public_path__ + "media/images/common/logo-8aebce09f3b72a092670db0a4bc9c1dc.png";